import React, { useMemo } from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Typography,
  Tags,
  Stack,
} from '@gogame/components';
import groupBy from 'lodash/groupBy';

const AITags = ({ data }) => {
  const grouped = useMemo(() => {
    let groupedData = groupBy(data, 'category');
    let result = Object.entries(groupedData).map(([key, value]) => {
      return [key, value.map((el) => el.name)];
    });
    return Object.fromEntries(result);
  }, [data]);

  const categories = useMemo(() => {
    return Object.keys(grouped) || [];
  }, [grouped]);

  if (!data?.length) {
    return (
      <Stack flex={1} justifyContent={'center'} alignItems={'center'}>
        <Typography color={'textSecondary'}>No AI Tags</Typography>
      </Stack>
    );
  }

  return (
    <DescriptionList data={grouped} disableGutters={true} termWidth={'20%'}>
      {categories.map((category) => {
        return (
          <DescriptionItem
            label={category}
            field={category}
            type={({ value }) => {
              return <Tags data={value} lineClamp={4} />;
            }}
          />
        );
      })}
    </DescriptionList>
  );
};

export default AITags;
